module.exports = __webpack_public_path__ + "img/FILTER.51e98283.svg";